module.exports = __webpack_public_path__ + "img/瓶中花-2.56d46d47.jpg";